module.exports = __webpack_public_path__ + "static/media/connect_1.fa4256c0.jpg";